var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpperAbdomen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "42px",
    height: "21px",
    viewBox: "0 0 47 21",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Upper Abdomen") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Humanuculus",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    fillOpacity: 0.195858829
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard-Copy-39",
    transform: "translate(-192.000000, -134.000000)",
    fill: "#1E428A"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Front-Body---Selections",
    transform: "translate(175.074098, 42.681852)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.6329017,91.3353894 L63.4260371,91.3181483 C62.923161,95.9280635 62.5427821,99.4309371 62.2849003,101.826769 C62.0270184,104.222601 62.1538884,107.719727 62.6655102,112.318148 L18.503241,112.318148 L19.1473881,105.330311 L17.6329017,91.3353894 Z",
    id: "Upper-Abdomen"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpperAbdomen);
export default __webpack_public_path__ + "static/media/UpperAbdomen.ec18209f916212cdbed3ee6a6654aa83.svg";
export { ForwardRef as ReactComponent };